(function () {
  'use strict';

  function closeDetails(root) {
    root.querySelectorAll('details[open]').forEach(function (detail) {
      detail.removeAttribute('open');
    });
  }

  function initShell() {
    var header = document.querySelector('.site-header');
    if (header && header.dataset.esShellInit !== 'true') {
      header.dataset.esShellInit = 'true';

      header.querySelectorAll('.es-nav-details').forEach(function (detail) {
        detail.addEventListener('toggle', function () {
          if (!detail.open) return;
          header.querySelectorAll('.es-nav-details[open]').forEach(function (other) {
            if (other !== detail) other.removeAttribute('open');
          });
        });
      });

      document.addEventListener('pointerdown', function (event) {
        if (!header.contains(event.target)) closeDetails(header);
      });

      header.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          closeDetails(header);
          var active = document.activeElement;
          if (active && active.closest('.es-nav-details')) {
            var summary = active.closest('.es-nav-details').querySelector('summary');
            if (summary) summary.focus();
          }
        }
      });
    }

    document.querySelectorAll('[data-video-toggle]').forEach(function (button) {
      if (button.dataset.esVideoInit === 'true') return;
      button.dataset.esVideoInit = 'true';
      var targetId = button.getAttribute('aria-controls');
      var video = targetId ? document.getElementById(targetId) : button.closest('[data-video-wrap]')?.querySelector('video');
      if (!video) return;

      function updateLabel() {
        var paused = video.paused;
        button.setAttribute('aria-pressed', String(!paused));
        button.textContent = paused ? 'Play motion' : 'Pause motion';
      }

      button.addEventListener('click', function () {
        if (video.paused) {
          video.play().catch(function () {});
        } else {
          video.pause();
        }
        updateLabel();
      });
      video.addEventListener('play', updateLabel);
      video.addEventListener('pause', updateLabel);
      updateLabel();
    });

    var drawer = document.getElementById('NavDrawer');
    if (drawer && drawer.dataset.esResizeInit !== 'true') {
      drawer.dataset.esResizeInit = 'true';
      window.addEventListener('resize', function () {
        if (window.innerWidth <= 860 || !drawer.classList.contains('open')) return;
        drawer.classList.remove('open');
        drawer.setAttribute('aria-hidden', 'true');
        drawer.inert = true;
        document.body.classList.remove('nav-open');
        var trigger = document.querySelector('.mobile-menu-btn');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShell);
  } else {
    initShell();
  }
  document.addEventListener('shopify:section:load', initShell);
})();
